import * as React from "react";
import { OverviewItem } from "../shared/overview-item";

export interface DestinationOverviewProps {
    chartsForText?: string;
    destinationsInText?: string;
    similarDestinationsText?: string;
    otherDestinationsText?: string;
    weatherOverviewText?: string;
    lastWeekWeatherText?: string;
    includeFaqs?: boolean;
    destinationsFirst?: boolean;
}

export const DestinationOverview = ({
    chartsForText,
    destinationsInText,
    similarDestinationsText,
    otherDestinationsText,
    weatherOverviewText,
    lastWeekWeatherText,
    includeFaqs,
    destinationsFirst
}: DestinationOverviewProps) => {
    return (
        <>
            <ul className="article m-auto mb-6 mt-10">
                {destinationsInText && destinationsFirst && (
                    <OverviewItem
                        id="#destinations-in"
                        name={destinationsInText}
                    />
                )}
                {chartsForText && (
                    <OverviewItem id="#weather-chart" name={chartsForText} />
                )}
                {destinationsInText && !destinationsFirst && (
                    <OverviewItem
                        id="#destinations-in"
                        name={destinationsInText}
                    />
                )}
                {similarDestinationsText && (
                    <OverviewItem
                        id="#destinations-similar"
                        name={similarDestinationsText}
                    />
                )}
                {otherDestinationsText && (
                    <OverviewItem
                        id="#destinations-other"
                        name={otherDestinationsText}
                    />
                )}
                {lastWeekWeatherText && (
                    <OverviewItem
                        id="#current-weather"
                        name={lastWeekWeatherText}
                    />
                )}
                {weatherOverviewText && (
                    <OverviewItem
                        id="#weather-overview"
                        name={weatherOverviewText}
                    />
                )}
                {includeFaqs && <OverviewItem id="#faqs" name={"FAQs"} />}
            </ul>
        </>
    );
};
